/**
 * ColumnsDropdown — show/hide column picker used by Dashboard and Job Sheet.
 * Closes on outside click and on Escape; toggle list comes from useColumnPrefs.
 */

import { useEffect, useRef, useState } from 'react';
import Icon from './Icons.jsx';

export default function ColumnsDropdown({ allToggleable, visible, onToggle }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-haspopup="true"
        className="btn text-sm gap-1.5 border border-border-base bg-card hover:bg-slate-50"
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="3" width="5" height="18" rx="1"/><rect x="10" y="3" width="5" height="18" rx="1"/><rect x="17" y="3" width="5" height="18" rx="1"/>
        </svg>
        Columns
        <Icon name="chevDown" size={11} />
      </button>
      {open && (
        <div className="orin-pop absolute right-0 top-full mt-1 z-50 w-44 bg-card border border-border-base rounded-lg shadow-xl py-1.5">
          <div className="px-3 pb-1.5 pt-0.5 text-[10px] uppercase tracking-wider text-muted font-semibold border-b border-border-base mb-1">
            Show / hide
          </div>
          {allToggleable.map((col) => (
            <label key={col.id} className="flex items-center gap-2.5 px-3 py-1.5 hover:bg-canvas cursor-pointer text-sm">
              <input
                type="checkbox"
                checked={visible.includes(col.id)}
                onChange={() => onToggle(col.id)}
                className="rounded"
                style={{ accentColor: 'var(--accent)' }}
              />
              <span className="text-ink">{col.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
